export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'LOGIN': {
                'TITLE': 'Login'
            },
            'INSPETIONREPORT': {
                'TITLE': 'InspectionReport'
            }
        }
    }
};



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/navigation/i18n/en.ts